var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.067.82a.75.75 0 0 0-1.023.932L3.704 12 .044 22.248a.75.75 0 0 0 1.023.932l22.5-10.5a.75.75 0 0 0 0-1.36zm3.706 9.714L2.06 2.94 21.477 12 2.06 21.06l2.713-7.594 8.355-1.044a.425.425 0 0 0 0-.844z",
  clipRule: "evenodd"
})));
export default SvgSendMessage;